/**
 * Loading state: auth in progress (Teams / IFS validation, login).
 */
import React from "react";
import { Stack } from "@fluentui/react";
import { USER_DATA_LOAD_STATUS } from "../../../redux/constants/metaData";
import mainPageBackground from "../../../assets/vectorIllustrationTeamWork.svg";

function getStatusText(dataLoadStatus, message) {
  switch (dataLoadStatus) {
    case USER_DATA_LOAD_STATUS.onLoading:
      return "Loading...";
    case USER_DATA_LOAD_STATUS.onAzureUserAuthentication:
      return "Authenticating Teams User";
    case USER_DATA_LOAD_STATUS.onIFSUserValidation:
      return "Authenticating Teams User";
    case USER_DATA_LOAD_STATUS.onIFSUserLogin:
      return "Waiting for IFS User Authentication";
    default:
      return message || "";
  }
}

export default function LoadingView({ innerRef, imgStyles, userDataLoadStatus, message }) {
  return (
    <div ref={innerRef}>
      <Stack vertical tokens={{ childrenGap: 0, padding: 0 }}>
        <Stack.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              overflow: "hidden",
              height: "95vh",
            }}
          >
            <img
              id="mainPageBackground"
              src={mainPageBackground}
              style={imgStyles}
              alt="Welcome to Addovation Share"
              loading="eager"
              decoding="sync"
              fetchPriority="high"
            />
          </div>
        </Stack.Item>
        <Stack.Item>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "5vh",
            }}
          >
            <p>{getStatusText(userDataLoadStatus, message)}</p>
          </div>
        </Stack.Item>
      </Stack>
    </div>
  );
}
